import { render, staticRenderFns } from "./comp_Paypal-CheckoutConfirmButton.vue?vue&type=template&id=58b4db79&"
import script from "./comp_Paypal-CheckoutConfirmButton.vue?vue&type=script&lang=js&"
export * from "./comp_Paypal-CheckoutConfirmButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VProgressLinear,VSnackbar})
